import Vue from "vue";
import Http from "vue-resource";
import { VueMaskDirective } from "v-mask";
import router from "./router";
import store from "./store";
import config from "./config";
import { registerGTM } from "./registerGTM";
import { registerMixpanel } from "./registerMixpanel";
require("./global-components");

// Initialize tracking
registerGTM();
registerMixpanel();

Vue.use(Http);
Vue.directive("mask", VueMaskDirective);

const App = new Vue({
    store,
    router: router,
    data: function () {
        return {
            client: {
                id: null,
                name: null,
                email: null,
                fbId: null,
                firstname: null,
                whatsapp: null,
                token: null,
            },
            place: {
                name: null,
                logo: null,
                slug: null,
            },
            lang: "ptBr",
        };
    },
    methods: {
        updateClient: function (client) {
            this.client = client;
            if (client.id) {
                this.client.firstname = "";
                if (client.name) {
                    let firstname = client.name.split(" ")[0];
                    this.client.firstname = firstname;
                }
                mixpanel.identify(client.id);
                mixpanel.people.set("name", client.name);
                mixpanel.people.set("email", client.email);
                if (this.place.slug) {
                    mixpanel.register({ place: this.place.slug });
                }
            }
        },
        updatePlace: function (place) {
            mixpanel.register({ place: place.slug });
            this.place = place;
        },
        logout: function () {
            this.client = {
                id: null,
                name: null,
                email: null,
                fbId: null,
                firstname: null,
            };
            window.location = window.location.origin + window.location.pathname;
        },
    },
}).$mount("#app");
